import { render, staticRenderFns } from "./faceBox.vue?vue&type=template&id=9aad70b4&scoped=true&"
import script from "./faceBox.vue?vue&type=script&lang=js&"
export * from "./faceBox.vue?vue&type=script&lang=js&"
import style0 from "./faceBox.vue?vue&type=style&index=0&id=9aad70b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aad70b4",
  null
  
)

export default component.exports